import Entity from "./Entity";

class Alert extends Entity {
  constructor() {
    super();
    this.id = null;
    this.actorIds = [];
    this.cves = [];
    this.techniqueIds = null;
    this.subTechniqueIds = null;
    this.tacticIds = null;
    this.sourceType = "MITRE";
    this.signatures = [];
    this.type = null;
    this.adversaryTools = [];
    this.name = "";
    this.description = "";
    this.format = "YAML";
    this.supportedPlatforms = [];
    this.executors = [];
    this.recommendation = "";
    this.references = [];
    this.affectedPrograms = [];
    this.version = 2;
    this.shortName = "";
    this.attackPhase = "";
    this.preventionControls = [];
    this.prerequisiteTools = [];
    this.authentication = false;
    this.credentialType = null;
    this.categoryIds = [];
    this.categoryTypeIds = [];
    this.target = "";
    this.status = "";
    this.level = null;
  }
}
export default Alert;
